export class ProductNotExistOrNotPublishedError extends Error {
  constructor() {
    super(
      `Product not published or doesn't exist`
    );
    this.name = "ProductNotExistOrNotPublishedError";
  }
}
